import { render, staticRenderFns } from "./law.vue?vue&type=template&id=6eb1096e&scoped=true&"
import script from "./law.vue?vue&type=script&lang=js&"
export * from "./law.vue?vue&type=script&lang=js&"
import style0 from "./law.vue?vue&type=style&index=0&id=6eb1096e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb1096e",
  null
  
)

export default component.exports